import { render, staticRenderFns } from "./relocateStock.vue?vue&type=template&id=3ee821ba&scoped=true"
import script from "./relocateStock.vue?vue&type=script&lang=js"
export * from "./relocateStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee821ba",
  null
  
)

export default component.exports